import { render, staticRenderFns } from "./FooterNav.vue?vue&type=template&id=6c151c84&scoped=true&"
import script from "./FooterNav.vue?vue&type=script&lang=js&"
export * from "./FooterNav.vue?vue&type=script&lang=js&"
import style0 from "./FooterNav.vue?vue&type=style&index=0&id=6c151c84&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c151c84",
  null
  
)

export default component.exports